import { __awaiter, __generator } from "tslib";
import { logger } from '../../logger';
export function loadSnitcher(analytics, options) {
    if (!options.token) {
        logger.error('Token is missing for the Snitcher intent source. Make sure it is included in your script setup.');
        return;
    }
    function dreamdataCallback(identification) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var reveal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!identification ||
                            identification.type !== 'business' ||
                            ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website))
                            return [2 /*return*/];
                        reveal = identification.company;
                        return [4 /*yield*/, analytics.group(null, {
                                website: reveal.domain,
                                intentSource: 'snitcher',
                                name: reveal.name || undefined,
                                industry: reveal.industry || undefined,
                                number_of_employees: reveal.employee_range || undefined,
                                annual_revenue: reveal.revenue.amount || undefined,
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    window.SpotterSettings = {
        token: options.token,
        callback: dreamdataCallback,
    };
}
//# sourceMappingURL=snitcher.js.map